
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Image": [
      "CloudinaryImage"
    ],
    "PvWizardQuestion": [
      "PvWizardMultiQuestionType",
      "PvWizardQuestionTypeButton",
      "PvWizardQuestionTypeDropdown"
    ],
    "PvWizardResultSection": [
      "PvWizardResultSectionSolarStorage",
      "PvWizardResultSectionSolarYield",
      "PvWizardResultSectionSunKilometers",
      "PvWizardResultSectionSystemCapacity"
    ],
    "RequestError": [
      "BadRequestError",
      "InternalServerError",
      "NotFoundError"
    ]
  }
};
      export default result;
    